export default __webpack_public_path__ + "static/media/upload-icon.5e8b82a7.svg";